import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { notificationsEndpoints } from '../../../../constants';
import { UpdateNotificationStatus } from '../../schemas/notification.schema';

class NotificationsApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  updateNotification = async (
    updateNotificationStatus: UpdateNotificationStatus
  ): Promise<void> => {
    return this.#requestInstance.patch(
      notificationsEndpoints.updateNotification(updateNotificationStatus?.id),
      {
        status: updateNotificationStatus?.status,
      }
    );
  };
}

export const notificationsApi = new NotificationsApi(axios);
